import defaultTheme from 'tailwindcss/defaultTheme';
import twColors from 'tailwindcss/colors';
import ColorConvert from 'color';

const mutableConfig = {
    theme: {
        screens: { ...(defaultTheme.screens ?? {}) },
        fontFamily: { ...(defaultTheme.fontFamily ?? {}) },
    },
} as any;

/**
 * すべてのデフォルトカラーに `DEFAULT` (例: .text-red -> .text-red-500) を設定
 */
export function addDefaultColor<T extends Record<string, unknown>>(colors: T): T {
    return Object.keys(colors).reduce((acc, colorName) => {
        const color = (colors as Record<string, unknown>)[colorName];
        if (typeof color === 'object' && color !== null && (color as Record<string, unknown>)[500]) {
            (acc as Record<string, unknown>)[colorName] = {
                ...(color as Record<string, unknown>),
                DEFAULT: (color as Record<string, unknown>)[500],
            };
        } else {
            (acc as Record<string, unknown>)[colorName] = color;
        }
        return acc;
    }, {} as T);
}

/**
 * ベースカラーから50から900までのカラーシェードを生成します。
 */
export function generateColorShades(baseColor: string) {
    const color = ColorConvert(baseColor);
    return {
        50: color.lighten(0.9).hex(),
        100: color.lighten(0.8).hex(),
        200: color.lighten(0.6).hex(),
        300: color.lighten(0.4).hex(),
        400: color.lighten(0.2).hex(),
        500: color.hex(),
        600: color.darken(0.2).hex(),
        700: color.darken(0.4).hex(),
        800: color.darken(0.6).hex(),
        900: color.darken(0.8).hex(),
        950: color.darken(0.9).hex(),
    };
}

// テーマカラー
export const themeColors: Record<string, string> = {};

// テーマカラーのレベルパース
const themeShadeColors = Object.fromEntries(
    Object.entries(themeColors).map(([key, value]) => [key, generateColorShades(value)])
);

export const colors = {
    ...addDefaultColor(twColors as unknown as Record<string, unknown>),
    ...addDefaultColor(themeShadeColors),
} as Record<string, string | Record<string, string>>;

// screens
export const screens = mutableConfig.theme?.screens ?? {};

// フォントファミリー
mutableConfig.theme.fontFamily.serif = [
    'YakuHanMPs',
    '"Hiragino Mincho ProN"',
    '"Yu Mincho"',
    '"Noto Serif JP"',
    'serif',
];
mutableConfig.theme.fontFamily.sans = [
    'YakuHanJPs',
    '"Hiragino Sans"',
    'system-ui',
    '-apple-system',
    '"Segoe UI"',
    '"Noto Sans JP"',
    'sans-serif',
];

export { mutableConfig as config };
